import { styled } from '@mui/material/styles'

import { Pin } from '@/icons'
import { Text } from '@/local/components'

import { Stack } from '@mui/material'

import { useTexts } from '../useTexts'

const StyledStack = styled(Stack)({
  maxWidth: 260,
})

export function Info() {
  const texts = useTexts()

  return (
    <StyledStack direction="row" height="100%" width="100%" alignItems="center">
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        sx={{ marginLeft: '20px', marginRight: '30px', width: '50px' }}
        flexShrink={0}
      >
        <Pin size={20} color="$nightRider" />

        <Text size="$s" color="$nightRider" textAlign="center">
          {texts.inspect}
        </Text>
      </Stack>

      <Stack direction="column" flexShrink={0} width="100%" height="100%" justifyContent="center">
        <Text size="$m" color="$nightRider" weight="$semiBold" textAlign="left">
          {texts.mapInspectorTool}
        </Text>

        <Text size="$m" color="$nightRider" textAlign="left">
          {texts.inspectPointOnMap}
        </Text>
      </Stack>
    </StyledStack>
  )
}
